import {
  AppBar,
  Avatar,
  Badge,
  Box,
  Button,
  Container,
  Divider,
  Drawer,
  Grid,
  IconButton,
  ImageListItem,
  Link,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { ReactNode, useContext, useReducer } from "react";
import LogoImage from "../../../assets/images/ZeaIQ-Logo.svg";
import MenuIcon from "@mui/icons-material/Menu";
import variables from "../../../assets/styles/variables.module.scss";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import userContext from "../../Context/UserContext";
import AccountReducer, {
  initialStateAuth,
} from "../../Store/AuthReducer/AuthReducer";
import { SetLogout } from "../../Store/AuthReducer/AuthActions";
import { useDispatch } from "react-redux";
import ProImg from "../../../assets/images/defaultProfileImage.jpg";

interface MyComponentProps {
  children?: ReactNode; // Ensure you define children prop type
}

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

const MainLayout: React.FC<MyComponentProps> = ({}) => {
  // const  window } = children;
  const {user} = useContext(userContext);
  const dispatch = useDispatch();

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const drawerWidth = 240;
  const location = useLocation();
  const navigate = useNavigate();
  const navItems = [
    { name: "Home", path: "/home" },
    { name: "Agents", path: "/agents" },
    // { name: "Multi Agent", path: "/multi-agent" },
    { name: "Knowledge", path: "/knowledge-bases" },
    { name: "Tools", path: "/tools" },
    { name: "Apps", path: "/app" },
    // { name: "Templates", path: "/templates" },
    // { name: "Settings", path: "/settings" },
    // { name: "Groups", path: "/groups" },
    { name: "Help", path: "/help" },
  ];
  const container =
    window !== undefined ? () => window.document.body : undefined;
  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = (path?: string) => {
    setAnchorElUser(null);
    if (path) navigate(path);
  };

  const handleCloseUserMenus = () => {
    dispatch(SetLogout());
    // navigate('/login')
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Box sx={{ py: 2 }}>
        <img
          src={LogoImage}
          alt="Company Logo"
          style={{ width: 120, height: "auto" }}
        />
      </Box>
      <Divider />
      <List>
        {navItems.map((item, index) => (
          <ListItem key={index} disablePadding>
            <ListItemButton sx={{ textAlign: "center" }}>
              <ListItemText
                primary={item.name}
                onClick={() => navigate(item.path)}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
  return (
    <>
      <Container
        maxWidth={false}
        sx={{ 
          borderBottom: `1px solid ${variables.borderColor}` ,
          position: "sticky",
          top: "0",
          zIndex: "6",
          backgroundColor: variables.whiteColor,
        }}
      >
        <AppBar
          component="nav"
          position="static"
          elevation={0}
          sx={{ px: { lg: 1 } }}
        >
          <Toolbar
            disableGutters
            sx={{
              display: "flex",
              justifyContent: "space-between",
              py: 2,
            }}
          >
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{
                mr: 1,
                display: { md: "none" },
                color: variables.blackColor,
              }}
            >
              <MenuIcon />
            </IconButton>
            <ImageListItem
              sx={{
                marginRight: { xs: "auto", sm: "auto", md: "unset" },
                "&:hover": {
                  cursor: "pointer",
                  transform: "scale(1.05)",
                  transition: "transform 0.3s ease-in-out",
                },
              }}
              onClick={() => navigate("/home")}
            >
              <img
                src={LogoImage}
                alt="Company Logo"
                style={{ width: 160, height: "auto" }}
              />
            </ImageListItem>

            <Box sx={{ display: { xs: "none", md: "block" } }}>
              {/* {navItems.map((item, index) => (
                <Button
                  key={index}
                  sx={{
                    color: variables.textColor,
                    textTransform: "capitalize",
                  }}
                  onClick={() => navigate(item.path)}
                >
                  {item.name}
                </Button>
              ))} */}
              <Box
                sx={{
                  display: "flex",
                }}
              >
                {navItems.map((item, index) => (
                  <ListItem key={index} disablePadding>
                    <ListItemButton
                      sx={{
                        textAlign: "center",
                        "&:hover": {
                          backgroundColor: "transparent", // Remove hover background color
                        },
                      }}
                    >
                      <ListItemText
                        primary={item.name}
                        onClick={() => navigate(item.path)}
                        sx={{ whiteSpace: "nowrap", }}
                        primaryTypographyProps={{
                          fontSize: "16px", // Set font size here
                          fontWeight: "500", // Optional: Adjust font weight
                          color: location.pathname === item.path ? variables.primaryColor : "text.primary",
                        }}
                      />
                    </ListItemButton>
                  </ListItem>
                ))}
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              {/* <Box
                sx={{
                  display: {
                    xs: "none", // Hide on extra-small devices
                    sm: "block", // Show on small devices and above
                  },
                }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    backgroundColor: "#C8F1DF",
                    px: 2,
                    pb: 0.5,
                  }}
                >
                  <Typography variant="caption" fontWeight="500">
                    ASML / Contributor
                  </Typography>
                </Paper>
              </Box> */}
              {/* <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <StyledBadge
                overlap="circular"
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                variant="dot"
              >
                <Avatar src="/broken-image.jpg" />
              </StyledBadge>
              <Typography variant="body1" fontWeight="bold"
                sx={{ color: textColor, display: { xs: "none", md: "block" } }}
              >
                Jacob Mathew
              </Typography>
            </Box> */}
              <Box sx={{ flexGrow: 0 }}>
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <StyledBadge
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    variant="dot"
                  >
                    <Avatar src={ProImg} />
                  </StyledBadge>
                </IconButton>

                <Menu
                  sx={{ mt: "45px" }}
                  id="menu-appbar"
                  anchorEl={anchorElUser}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorElUser)}
                  onClose={() => handleCloseUserMenu()}
                  PaperProps={{
                    sx: { minWidth: "180px" },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      px: 2,
                    }}
                  >
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      sx={{
                        color: variables.textColor,
                      }}
                    >
                      {/* Jacob Mathew */}
                      {user && user.full_name}
                    </Typography>
                    <Typography variant="caption" fontWeight="400" gutterBottom>
                    {user && user.organization}
                    </Typography>
                  </Box>

                  <Divider component="li" sx={{ my: 1 }} />
            
                  <MenuItem onClick={() => handleCloseUserMenu("/userprofile")}>
                    <Typography variant="body2">Profile</Typography>
                  </MenuItem>
                  <Divider component="li" />
                  <MenuItem onClick={() => handleCloseUserMenus()}>
                    <Typography variant="body2">Log Out</Typography>
                  </MenuItem>
                </Menu>
              </Box>
            </Box>
          </Toolbar>
        </AppBar>
        <nav>
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: "block", md: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
              },
            }}
          >
            {drawer}
          </Drawer>
        </nav>
      </Container>
      {/* {children} */}

      <Box
        sx={{
          // minHeight: "calc(100vh - 78px)",
          // overflow: "auto",
        }}
      >
        <Outlet /> {/* This will render nested routes */}
      </Box>
    </>
  );
};
export default MainLayout;
